import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import CommandRepo from './pages/CommandRepo';
import FirmwareRepo from './pages/FirmwareRepo';
import Audit from './pages/Audit';
import Settings from './pages/Settings';
import './App.css';
import './styles/global.css';

const ProtectedLayout: React.FC = () => {
  const token = localStorage.getItem('token');
  const [isSidebarOpen, setSidebarOpen] = React.useState(false);

  React.useEffect(() => {
    // Prevent background scroll when the sidebar overlay is open
    document.body.style.overflow = isSidebarOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isSidebarOpen]);

  if (!token) return <Navigate to="/login" />;
  return (
    <div className={`app-shell ${isSidebarOpen ? 'sidebar-open' : ''}`}>
      <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="app-main">
        <button className="sidebar-toggle" onClick={() => setSidebarOpen(s => !s)} aria-label="Toggle sidebar">☰</button>
        <Outlet />
      </main>
      {isSidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/app" element={<ProtectedLayout />}> 
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="command-repo" element={<CommandRepo />} />
          <Route path="firmware-repo" element={<FirmwareRepo />} />
          <Route path="audit" element={<Audit />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
